export const getSeoMetadata = (pathname) => {
  const baseUrl = "https://newcontent.xane.ai/";
  const industryKeywords = [
    "AI solutions India",
    "industrial automation",
    "machine vision inspection",
    "predictive maintenance AI",
    "NLP for manufacturing",
    "computer vision solutions",
  ];

  const isBlogPage = pathname.includes("/blog/");

  const pageMetadata = {
    "/": {
      title: "Xane AI - AI-Powered Industrial Automation Solutions | India",
      description:
        "Deploy no-code AI solutions for quality inspection, predictive maintenance with 30% faster defect detection for manufacturing industries.",
      keywords: [
        ...industryKeywords,
        "AI quality control",
        "factory automation",
        "AI-powered quality inspection",
        "seamless platform integration",
        "interactive and accessible digital content",
        "simplifying onboarding",
        "on-demand support",
        "AI-powered quality inspection and computer vision",
        "dynamic digital guides",
        "maximizing engagement",
        "scan-to-diagnose flows",
        "inspection systems powered by AI",
        "accurate diagnostics",
        "engagement technology powered by AI natural language processing services",
        "industrial AI automation solutions",
        "strong digital interface",
        "increased revenue",
        "in-built paywalls",
        "AI-driven support for onboarding",
        "AI-powered quality inspection and computer vision AI",
        "natural language processing",
        "digital engagement",
        "AI-powered quality inspection",
        "computer vision",
        " NLP-driven insights",
      ].join(", "),
      schemaType: "WebSite",
    },
    "/about": {
      title: "About Xane AI - Leading AI Solutions Provider for Industries",
      description:
        "Xane AI is revolutionizing industrial automation with computer vision and NLP. Trusted by 50+ factories across India for AI-driven quality control.",
      keywords: [
        ...industryKeywords,
        "industrial AI experts",
        "AI-Powered Innovation",
        "AI-powered quality inspection",
        "computer vision AI solutions",
        "natural language processing services",
        "automate complex workflows",
        "AI-driven technology",
        "reduces costs",
        "AI tools",
        "interactive digital guides",
        "increase customer retention",
        "human cognitive",
        "digitally immersive",
        "manufacturers with an AI-powered quality inspection system",
        "computer vision in automotive industry",
        "instant diagnostics",
        "manual and interactive guides",
        "AI-driven digital reference guide",
        "scan-to-diagnose technologies",
        "AI-powered inspection systems",
        "predictive defect prevention",
        "effortless access to manuals",
        "after-sales services with real-time AI assistance",
        "AI-powered interactive manual for home appliances",
        "AI-driven fault detection",
        "interactive guides",
        "digitalized flight manuals",
        "AI-driven maintenance diagnostics",
        "real-time diagnostics",
        "AI-powered digital advice",
        "interactive manuals and immediate AI support",
      ].join(", "),
      schemaType: "Organization",
    },
    "/works": {
      title: "Our AI Solutions - Industrial Case Studies | Xane AI",
      description:
        "Explore our AI implementation success stories in manufacturing, automotive and electronics industries with proven ROI metrics.",
      keywords: [
        ...industryKeywords,
        "AI case studies",
        "manufacturing success stories",
        "AI-powered assistant",
        "AI-powered digital engagement",
        "no-code tools ingest complex data",
        "AI-powered quality inspection system",
        "AI natural language processing services",
        "computer vision, and OCR technology",
        "computer vision",
        "OCR technology",
        "digitize any paper manual",
        "unified post-sales experience",
        "AI-powered inspection systems",
        "AI-driven insights",
        "seamless integration",
        "AI-powered interactive manuals for home appliances",
        "AI-powered quality inspection systems",
        "computer vision for industrial inspection",
        "AI natural language processing services",
        "high-precision diagnostics and real-time support",
        "AI-powered home appliance manuals, a digital assistant for appliance setup",
        "AI-driven fault detection, predictive defect prevention, and AI-powered visual inspection for production lines",
        "images or text",
        "AI-driven consumer electronics solutions",
        "AI-powered inspection systems",
        "AI-driven assistance in manufacturing",
      ].join(", "),
      schemaType: "ItemList",
    },
    "/blogs": {
      title: "AI Insights - Latest Industrial Automation Trends | Xane AI",
      description:
        "Learn about AI applications in manufacturing through our expert articles, case studies and technology deep dives.",
      keywords: [...industryKeywords, "AI blog", "manufacturing technology trends"].join(", "),
      schemaType: "Blog",
    },
    "/contact": {
      title: "Contact Xane AI - Get AI Solutions for Your Industry",
      description:
        "Schedule a demo or consultation with our AI experts to implement quality inspection and automation solutions for your factory.",
      keywords: [...industryKeywords, "AI consultation", "contact AI experts"].join(", "),
      schemaType: "ContactPage",
    },
  };

  if (isBlogPage) {
    const blogId = pathname.split("/blog/")[1];
    const blogData = {
      title: `AI in Automotive Manufacturing - Case Study ${blogId}`,
      excerpt:
        "How we reduced defects by 40% using computer vision in automotive production lines.",
      tags: ["automotive AI", "quality inspection", "case study"],
    };

    return {
      title: `${blogData.title} | Xane AI`,
      description: blogData.excerpt,
      keywords: [...blogData.tags, ...industryKeywords].join(", "),
      schemaType: "BlogPosting",
    };
  }

  return (
    pageMetadata[pathname] || {
      title: "Xane AI - Industrial AI Solutions Provider",
      description:
        "AI-powered solutions for quality inspection, predictive maintenance and industrial automation.",
      keywords: industryKeywords.join(", "),
      schemaType: "WebPage",
    }
  );
};

export const getStructuredData = (schemaType, title, description, currentUrl) => {
  const baseSchema = {
    "@context": "https://schema.org",
    "@type": schemaType,
    name: title,
    description,
    url: currentUrl,
    publisher: {
      "@type": "Organization",
      name: "Xane AI",
      logo: {
        "@type": "ImageObject",
        url: "https://newcontent.xane.ai/logo.png",
      },
    },
  };

  switch (schemaType) {
    case "Organization":
      return {
        ...baseSchema,
        address: {
          "@type": "PostalAddress",
          streetAddress: "The Circle – Huda City Centre,",
          addressLocality: "Gurgaon",
          addressRegion: "Haryana",
          postalCode: "122002",
          addressCountry: "IN",
        },
        founder: {
          "@type": "Person",
          name: "Ayush Jain",
        },
        "co-founder": {
          "@type": "Person",
          name: "Sahil Narain",
        },
      };
    case "BlogPosting":
      return {
        ...baseSchema,
        headline: title,
        datePublished: "2025-04-25",
        author: {
          "@type": "Person",
          name: "Akash Kumar",
        },
      };
    default:
      return baseSchema;
  }
};
